import { boot } from 'quasar/wrappers'
import slugify from '../functions/slugify'

export default boot(({ app }) => {
	app.config.globalProperties.$slugify = slugify
})
